import React from 'react'
import { BiLineChartDown } from 'react-icons/bi'
import { FaGears } from 'react-icons/fa6'
import { GiReceiveMoney } from 'react-icons/gi'
import { TbDevicesPcOff } from 'react-icons/tb'
import { Button } from '../../components/ui/Button'

function AdvantagesOfWithdrawal({onGoToRegister}) {
    return (
        <section id="AdvantagesOfWithdrawal" className="bg-white py-16 px-6 max-w-7xl mx-auto text-center">
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                Vantagens do saque
            </span>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-5xl mx-auto mb-12 text-left">
                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <GiReceiveMoney className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Dinheiro rápido</h3>
                    <p className="text-gray-600 text-sm">
                        Saque o limite do cartão e receba na conta em poucos minutos.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <TbDevicesPcOff className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Sem consulta ao SPC/Serasa</h3>
                    <p className="text-gray-600 text-sm">
                        Já tem o cartão BMG? O saque está liberado, sem burocracia.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <BiLineChartDown className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Juros menores</h3>
                    <p className="text-gray-600 text-sm">
                        Taxas mais baixas que empréstimos ou cartão tradicional.
                    </p>
                </div>
                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <FaGears className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Desconto automático</h3>
                    <p className="text-gray-600 text-sm">
                        Parte do valor mínimo é descontado direto do benefício ou salário.
                    </p>
                </div>
            </div>

            <Button onClick={onGoToRegister} variant="outline">
                Contratar agora
            </Button>
        </section>
    )
}

export default AdvantagesOfWithdrawal